import { jsx as _jsx } from "react/jsx-runtime";
import { DownloadOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import SecondaryActionButton from 'components/SecondaryActionButton';
const DownloadButton = ({ onDownload, title, disabled, className, displayTextOnSmallScreen, breakpoint, id, }) => {
    return (_jsx(SecondaryActionButton, { onAction: onDownload, title: title, loadingMessage: txt('exportProgress'), icon: _jsx(DownloadOutlined, {}), disabled: disabled, async: true, className: className, size: "middle", displayTextOnSmallScreen: displayTextOnSmallScreen, breakpoint: breakpoint, id: id }));
};
export default DownloadButton;
